export type UploadStatusEnum = 'UPLOADED' | 'PENDING' | 'FAILED';

export const UploadStatusEnumValues = {
    Uploaded: 'UPLOADED' as UploadStatusEnum,
    Pending: 'PENDING' as UploadStatusEnum,
    Failed: 'FAILED' as UploadStatusEnum,
};
